import React, { useCallback } from 'react';
import { Platform, View } from 'react-native';
import colors from '~/assets/themes/colors';
import Text from '../Text';
import type { ItemProps } from '~/utils/services';

interface Props {
  data: ItemProps;
}

const ProtectionResumeItemCard: React.FC<Props> = ({ data }) => {
  const RenderIcon = useCallback(() => {
    const { icon: Icon } = data;

    return <Icon color={colors.protection[600]} width={24} height={24} />;
  }, [data]);

  return (
    <View
      className={`p-4 rounded-lg bg-light-100 shadow-md mb-2 ${
        Platform.OS === 'android' ? 'shadow-black/40' : ''
      }`}
    >
      <View className="flex-row items-center mb-2">
        <RenderIcon />

        <Text className="ml-2 text-sm text-gray-700">{data.title}</Text>
      </View>

      <Text className="text-xs text-gray-400">{data.description}</Text>
    </View>
  );
};

export default ProtectionResumeItemCard;
